class TreatHouseCopyEmail extends HTMLElement {
  connectedCallback() {
    const button = this.querySelector('[data-copy-email]');
    if (!button || this.copyButton === button) return;

    this.copyButton = button;
    button.hidden = false;
    button.addEventListener('click', () => this.copyEmail());
  }

  async copyEmail() {
    const button = this.copyButton;
    const field = this.querySelector('[data-copy-field]');
    const status = this.querySelector('[data-copy-status]');
    if (!button || button.disabled || !field || !status) return;

    button.disabled = true;
    status.textContent = '';
    try {
      if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(this.dataset.email);
      field.hidden = true;
      status.textContent = this.dataset.successMessage;
    } catch {
      field.hidden = false;
      status.textContent = this.dataset.fallbackMessage;
      field.focus();
      field.select();
    } finally {
      button.disabled = false;
    }
  }
}

if (!customElements.get('th-copy-email')) {
  customElements.define('th-copy-email', TreatHouseCopyEmail);
}
